import { CrewDocument } from '../Crew/queryBuilder';
import { DepartmentDocument } from '../Department/queryBuilder';
import { PositionDocument } from '../Position/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { EmployeeDocument, employeesPullQueryBuilder } from './queryBuilder';

export function employeesFamilyMember(
  configBuilder: ConfigBuilder,
  crews: FamilyMember<CrewDocument>,
  department: FamilyMember<DepartmentDocument>,
  positions: FamilyMember<PositionDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<EmployeeDocument> {
  const syncConfig = configBuilder<EmployeeDocument>(RxdbCollectionNameV2.EMPLOYEES);
  doNotAutoSync(syncConfig);

  // Note that `employeesPullQueryBuilder` actually uses the `siteEmployeeFeed` query,
  // and thus corresponds to the `site_employee` table in the database,
  // not the `employee` table.
  pull(syncConfig, employeesPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.EMPLOYEES, replicationState, [
    crews,
    department,
    positions,
    sites,
  ]);
}
